import {
  DeleteAvatarRequest,
  EmptyResponse,
  GetListForCreationResponse,
} from '~/types';
import { fetcher } from './config/fetcher';
import http from './config/http';

export const getListForCreation = async () => {
  return fetcher(() => http.get<GetListForCreationResponse>(`/avatars`));
};

export const deleteMyCreationCharacter = async ({
  avatar_id,
}: DeleteAvatarRequest) => {
  return fetcher(() => http.delete<EmptyResponse>(`/avatars/${avatar_id}`));
};

export const saveAvatar = async (formData: FormData) => {
  return fetcher(() =>
    http.post<EmptyResponse>('/avatars', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  );
};
